module.exports = __webpack_public_path__ + "img/img-933224.jpg";